import { render, staticRenderFns } from "./CKEditor copy.vue?vue&type=template&id=2c37a4d4&scoped=true"
import script from "./CKEditor copy.vue?vue&type=script&lang=js"
export * from "./CKEditor copy.vue?vue&type=script&lang=js"
import style0 from "./CKEditor copy.vue?vue&type=style&index=0&id=2c37a4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37a4d4",
  null
  
)

export default component.exports